import { useState } from "react";
import { Select, Space, Table, Tag, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import type { CommissionSettlement } from "@glow-price/shared";
import { formatPriceCNY } from "@glow-price/shared";

import { affiliateNetworksApi, commissionSettlementsApi } from "../api/resources";

export function CommissionSettlementsPage() {
  const [networkId, setNetworkId] = useState<string | undefined>();
  const [page, setPage] = useState(1);

  const networksQuery = useQuery({
    queryKey: ["affiliate-networks", "all"],
    queryFn: () => affiliateNetworksApi.list({ page: 1, pageSize: 200 }),
  });
  const networkOptions = (networksQuery.data?.items ?? []).map((n) => ({
    value: n.id,
    label: `${n.name} (${n.code})`,
  }));

  const list = useQuery({
    queryKey: ["commission-settlements", networkId, page],
    queryFn: () => commissionSettlementsApi.list({ networkId, page, pageSize: 30 }),
  });

  return (
    <div>
      <Space style={{ marginBottom: 16, justifyContent: "space-between", width: "100%" }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          佣金结算
        </Typography.Title>
        <Select
          allowClear
          placeholder="联盟"
          options={networkOptions}
          value={networkId}
          onChange={(v) => {
            setPage(1);
            setNetworkId(v);
          }}
          style={{ width: 240 }}
        />
      </Space>

      <Typography.Paragraph type="secondary">
        当前阶段结算表只读，由后台任务（待实现）按月聚合 affiliate_orders 生成。
      </Typography.Paragraph>

      <Table<CommissionSettlement>
        rowKey="id"
        loading={list.isLoading}
        dataSource={list.data?.items ?? []}
        pagination={{
          current: page,
          pageSize: 30,
          total: list.data?.total ?? 0,
          onChange: (p) => setPage(p),
          showSizeChanger: false,
        }}
        columns={[
          {
            title: "周期",
            render: (_, row) =>
              `${dayjs(row.periodStart).format("YYYY-MM-DD")} → ${dayjs(row.periodEnd).format("YYYY-MM-DD")}`,
          },
          {
            title: "联盟",
            dataIndex: "networkId",
            render: (v) => networkOptions.find((o) => o.value === v)?.label ?? v,
          },
          {
            title: "订单金额合计",
            dataIndex: "totalOrderAmount",
            render: (v) => formatPriceCNY(v),
            width: 140,
          },
          {
            title: "佣金合计",
            dataIndex: "totalCommissionAmount",
            render: (v) => formatPriceCNY(v),
            width: 140,
          },
          {
            title: "状态",
            dataIndex: "status",
            width: 100,
            render: (v) => <Tag>{v}</Tag>,
          },
        ]}
      />
    </div>
  );
}
